<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <div class="row mb-3">
                    <h4 style="margin-right: 5px" class="float-start">
                      {{ $t("cml_billing_detail_handling_overtime") }}
                    </h4>
                  </div>

                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("idBillingDetail")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingDetail"
                          :placeholder="$t('idBillingDetail')"
                          v-model="forms.idBillingDetail"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("idBillingHeader")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingHeader"
                          :placeholder="$t('idBillingHeader')"
                          v-model="forms.idBillingHeader"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("SAPMaterialCode")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="SAPMaterialCode"
                          :placeholder="$t('SAPMaterialCode')"
                          v-model="forms.SAPMaterialCode"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("SAPDivision")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="SAPDivision"
                          :placeholder="$t('SAPDivision')"
                          v-model="forms.SAPDivision"
                          disabled />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("chargeCategory_txt")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="chargeCategory"
                          :placeholder="$t('chargeCategory_txt')"
                          v-model="forms.chargeCategory"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("chargeType_txt")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="chargeType"
                          :placeholder="$t('chargeType_txt')"
                          v-model="forms.chargeType"
                          disabled />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{
                          $t("rateBaseDesc_txt")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rateBaseDesc"
                          :placeholder="$t('rateBaseDesc_txt')"
                          v-model="forms.rateBaseDesc"
                          disabled />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("qtyCharge") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="qtyCharge"
                          :placeholder="$t('qtyCharge')"
                          v-model="forms.qtyCharge"
                          disabled />
                      </div>
                      <div
                        class="col-md-3"
                        v-show="
                          this.roleName !== 'om_cml_basf01' &&
                          this.roleName !== 'om_cml_basf02_rm' &&
                          this.roleName !== 'om_cml_basf02_fg'
                        ">
                        <label class="form-label">{{ $t("rate") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rate"
                          :placeholder="$t('rate')"
                          v-model="forms.rate"
                          disabled />
                      </div>
                      <div
                        class="col-md-3"
                        v-show="
                          this.roleName !== 'om_cml_basf01' &&
                          this.roleName !== 'om_cml_basf02_rm' &&
                          this.roleName !== 'om_cml_basf02_fg'
                        ">
                        <label class="form-label">{{
                          $t("amountCategory")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="amountCategory"
                          :placeholder="$t('amountCategory')"
                          v-model="forms.amountCategory"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("remarks_txt")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="remark"
                          :placeholder="$t('remarks_txt')"
                          v-model="forms.remark"
                          disabled />
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()">
                    <span class="mdi mdi-download h4"></span>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <button
                    class="btn btn-primary text-light fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button">
                    <i class="link-icon mdi mdi-arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>
                </div>
                <span
                  v-if="
                    this.roleName == 'om_cml_basf01' ||
                    this.roleName == 'om_cml_basf02_rm' ||
                    this.roleName == 'om_cml_basf02_fg'
                  ">
                  <div
                    class="card-body"
                    v-if="this.formsHeader.status === 'COMPLETED'">
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-overtime"
                      ref="list-billing-cml-billing-detail-handling-overtime"
                      :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                      }"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns">
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>
                      <div slot="selected-row-actions">
                        <button
                          class="btn btn-danger btn-xs"
                          style="margin-right: 20px"
                          @click="selectionChangeStatus">
                          <i class="mdi mdi-send-outline"></i>
                          {{ $t("changeStatus") }}
                        </button>

                        <button
                          class="btn btn-success btn-xs"
                          @click="removeSelections">
                          <i class="mdi mdi-close"></i>
                          {{ $t("unselect_data_txt") }}
                        </button>
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'startOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="startOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="startOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearstartOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                          <span v-if="column.field == 'endOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="endOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="endOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearendOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a
                            href="#"
                            v-if="
                              permision_role.method_update &&
                              props.row.status === 'BILL'
                            "
                            title="NOT BILL"
                            @click.prevent="
                              changeStatusData(
                                props.index,
                                props.row,
                                'NOT BILL'
                              )
                            ">
                            <button class="btn btn-danger btn-xs">
                              NOT BILL
                            </button>
                          </a>
                          <a
                            href="#"
                            v-else
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'BILL')
                            ">
                            <button class="btn btn-primary btn-xs">BILL</button>
                          </a>
                        </span>
                        <span v-else-if="props.column.field == 'totalAmount'">
                          -
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          -
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                          <span v-else class="badge bg-danger"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div class="card-body" v-else>
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-overtime"
                      ref="list-billing-cml-billing-detail-handling-overtime"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns">
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'startOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="startOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="startOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearstartOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                          <span v-if="column.field == 'endOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="endOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="endOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearendOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'"> </span>
                        <span v-else-if="props.column.field == 'totalAmount'">
                          -
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          -
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                          <span v-else class="badge bg-danger"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </span>
                <span v-else>
                  <div
                    class="card-body"
                    v-if="this.formsHeader.status === 'COMPLETED'">
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-overtime"
                      ref="list-billing-cml-billing-detail-handling-overtime"
                      :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                      }"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns">
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>
                      <div slot="selected-row-actions">
                        <button
                          class="btn btn-danger btn-xs"
                          style="margin-right: 20px"
                          @click="selectionChangeStatus">
                          <i class="mdi mdi-send-outline"></i>
                          {{ $t("changeStatus") }}
                        </button>

                        <button
                          class="btn btn-success btn-xs"
                          @click="removeSelections">
                          <i class="mdi mdi-close"></i>
                          {{ $t("unselect_data_txt") }}
                        </button>
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'startOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="startOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="startOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearstartOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                          <span v-if="column.field == 'endOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="endOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="endOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearendOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a
                            href="#"
                            v-if="
                              permision_role.method_update &&
                              props.row.status === 'BILL'
                            "
                            title="NOT BILL"
                            @click.prevent="
                              changeStatusData(
                                props.index,
                                props.row,
                                'NOT BILL'
                              )
                            ">
                            <button class="btn btn-danger btn-xs">
                              NOT BILL
                            </button>
                          </a>
                          <a
                            href="#"
                            v-else
                            @click.prevent="
                              changeStatusData(props.index, props.row, 'BILL')
                            ">
                            <button class="btn btn-primary btn-xs">BILL</button>
                          </a>
                        </span>
                        <span v-else-if="props.column.field == 'totalAmount'">
                          {{ toCurrency(props.row.totalAmount) }}
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          {{ toCurrency(props.row.rate) }}
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                          <span v-else class="badge bg-danger"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                  <div class="card-body" v-else>
                    <vue-good-table
                      title="list-billing-cml-billing-detail-handling-overtime"
                      ref="list-billing-cml-billing-detail-handling-overtime"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns">
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                        <span v-if="column.filterOptions.customFilter">
                          <span v-if="column.field == 'startOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="startOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="startOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearstartOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                          <span v-if="column.field == 'endOvertime'">
                            <date-range-picker
                              style="width: 100%"
                              @update="endOvertimeChange"
                              control-container-class="form-control"
                              :locale-data="{ format: 'yyyy-mm-dd' }"
                              v-model="endOvertime"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="false"
                              :timePicker="false"
                              :showWeekNumbers="false">
                              <div
                                slot="header"
                                slot-scope="header"
                                class="slot">
                                <a
                                  @click="clearendOvertimeChange()"
                                  class="float-end"
                                  style="margin-right: 5px; color: red"
                                  >Clear Calendar</a
                                >
                                <span v-if="header.in_selection">
                                  - in selection</span
                                >
                                <br />
                              </div>
                            </date-range-picker>
                          </span>
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'"> </span>
                        <span v-else-if="props.column.field == 'totalAmount'">
                          {{ toCurrency(props.row.totalAmount) }}
                        </span>
                        <span v-else-if="props.column.field == 'rate'">
                          {{ toCurrency(props.row.rate) }}
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          <span
                            v-if="props.row.status == 'BILL'"
                            class="badge bg-primary"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                          <span v-else class="badge bg-danger"
                            ><h5>{{ props.row.status }}</h5></span
                          >
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "CmlBillingDetailOvertime",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      startOvertime: {
        startDate: null,
        endDate: null,
      },
      endOvertime: {
        startDate: null,
        endDate: null,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      idBillingHeader: [],
      detailDivisi: [],
      totalRecords: 0,
      roleName: "",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },

      startOvertimeFrom: "",
      firstBilingDate: "",
      startOvertimeTo: "",
      endOvertimeFrom: "",
      endOvertimeTo: "",

      rows: [],
      rowsSelection: [],
      fetchDataDropdown: [],
      fetchDataDropdownList: [],
      idCodeLkupsSelections: [],

      forms: {
        remark: "",
        rateBaseDesc: "",
        idBillingDetail: "",
        idBillingHeader: "",
        chargeCategory: "",
        chargeType: "",
        SAPMaterialCode: "",
        SAPDivision: "",
        amountCategory: "",
        addwho: "",
        editwho: "",
        qtyCharge: "",
        rate: "",
      },
      formsHeader: {
        idBillingHeader: "",
        tariffId: "",
        customerId: "",
        warehouseId: "",
        transactionToDate: "",
        transactionFromDate: "",
        status: "",
        amount: "",
        idRateHeader: "",
        transactionDate: "",
        addwho: "",
        editwho: "",
        adddate: "",
        editdate: "",
      },
    //   columns: [
    //     {
    //       label: this.$t("idDetail_Overtime"),
    //       field: "idDetail_Overtime",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("idDetail_Overtime"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("statusTxt"),
    //       field: "status",
    //       width: "100px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("statusTxt"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: ["BILL", "NOT BILL"], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("nameTxt"),
    //       field: "name",
    //       width: "200px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("nameTxt"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("startOvertime"),
    //       field: "startOvertime",
    //       width: "200px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: true,
    //         placeholder: this.$t("startOvertime"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("endOvertime"),
    //       field: "endOvertime",
    //       width: "200px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: true,
    //         placeholder: this.$t("endOvertime"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("hourOvertime"),
    //       field: "hourOvertime",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: false, // enable filter for this column
    //         customFilter: false,
    //       },
    //     },
    //     {
    //       label: this.$t("breakTime"),
    //       field: "breakTime",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: false, // enable filter for this column
    //         customFilter: false,
    //       },
    //     },
    //     {
    //       label: this.$t("totalOvertime"),
    //       field: "totalOvertime",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: false, // enable filter for this column
    //         customFilter: false,
    //       },
    //     },
    //     {
    //       label: this.$t("action_txt"),
    //       field: "actions",
    //       width: "100px",
    //       thClass: "text-center",
    //       sortable: false,
    //       filterOptions: {
    //         customFilter: false,
    //         enabled: false,
    //       },
    //     },
    //     {
    //       label: this.$t("rate_txt"),
    //       field: "rate",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: false, // enable filter for this column
    //         customFilter: false,
    //       },
    //     },
    //     {
    //       label: this.$t("amount_txt"),
    //       field: "totalAmount",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: false, // enable filter for this column
    //         customFilter: false,
    //       },
    //     },
    //     {
    //       label: this.$t("transactionType"),
    //       field: "transactionType",
    //       width: "200px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("all"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [
    //           "Overtime",
    //           "Overtime Palletizing",
    //           "Overtime 5R",
    //         ], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("nik"),
    //       field: "nik",
    //       width: "150px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("nik"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("position"),
    //       field: "position",
    //       width: "100px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("position"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //     {
    //       label: this.$t("sbu_sku"),
    //       field: "sbu_sku",
    //       width: "100px",
    //       thClass: "text-center",
    //       filterOptions: {
    //         enabled: true, // enable filter for this column
    //         customFilter: false,
    //         placeholder: this.$t("all"), // placeholder for filter input
    //         filterValue: "", // initial populated value for this filter
    //         filterDropdownItems: ["IC", "OEM", "PKG", "PMC", "REF"], // dropdown (with selected values) instead of text input
    //         trigger: "enter", //only trigger on enter not on keyup
    //       },
    //     },
    //   ],
      columns: this.getTableColumns(),
    };
  },
  watch: {},
  methods: {
    getTableColumns() {
      // Role yang tidak menampilkan kolom amountCategory
      const hiddenRoles = [
        "om_bulk",
        "om_cml_basf01",
        "om_cml_basf02_rm",
        "om_cml_basf02_fg",
      ];

      const roleName = this.permision_role?.role?.name;
      const isHiddenRole = hiddenRoles.includes(roleName);

      // Define columns with a fixed order
      let columns = [
        {
          label: this.$t("idDetail_Overtime"),
          field: "idDetail_Overtime",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("idDetail_Overtime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["BILL", "NOT BILL"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("nameTxt"),
          field: "name",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("nameTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("startOvertime"),
          field: "startOvertime",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("startOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("endOvertime"),
          field: "endOvertime",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("endOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("hourOvertime"),
          field: "hourOvertime",
          thClass: "text-center",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
          },
        },
        {
          label: this.$t("breakTime"),
          field: "breakTime",
          thClass: "text-center",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
          },
        },
        {
          label: this.$t("totalOvertime"),
          field: "totalOvertime",
          thClass: "text-center",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
          },
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          width: "100px",
          thClass: "text-center",
          sortable: false,
          filterOptions: {
            customFilter: false,
            enabled: false,
          },
        },
        !isHiddenRole
          ? {
              label: this.$t("rate_txt"),
              field: "rate",
              thClass: "text-center",
              filterOptions: {
                enabled: false, // enable filter for this column
                customFilter: false,
              },
            }
          : null,
        !isHiddenRole
          ? {
              label: this.$t("amount_txt"),
              field: "totalAmount",
              thClass: "text-center",
              filterOptions: {
                enabled: false, // enable filter for this column
                customFilter: false,
              },
            }
          : null,
        {
          label: this.$t("transactionType"),
          field: "transactionType",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("all"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [
              "Overtime",
              "Overtime Palletizing",
              "Overtime 5R",
            ], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("nik"),
          field: "nik",
          width: "150px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("nik"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("position"),
          field: "position",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("position"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("sbu_sku"),
          field: "sbu_sku",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("all"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["IC", "OEM", "PKG", "PMC", "REF"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("reason"),
          field: "reason",
          width: "100px",
          thClass: "text-center",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("reason"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ];

      // Filter kolom null (saat hidden) dari array
      return columns.filter((column) => column !== null);
    },

    getDataDropdownList() {
      //const baseURI = this.$settings.endPointBilling + "dashboard/master-code/get-data-master-code-detail?code_type=SBU_SKU_LIST";
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-wms-code-cml?codeType=CHARGE_TYPE&category=OV";

      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          //this.fetchDataDropdown  = response.data.datas;
          this.fetchDataDropdown = response.data.datas.data;
          //console.log(this.fetchDataDropdown);
          this.fetchDataDropdown.forEach((value) => {
            //this.fetchDataDropdownList.push(value.code_desc);
            this.fetchDataDropdownList.push(value.codeDesc);
          });
          //console.log(JSON.stringify(this.fetchDataDropdownList));
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    changeStatusData(index, row, statusNya) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetail_Overtimes: [row.idDetail_Overtime],
            status: statusNya,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-overtime-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    selectionChangeStatus() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: "NOT BILL",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;

          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetail_Overtimes: this.idCodeLkupsSelections,
            status: "BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-overtime-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = true;
          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.forms.idBillingDetail,
            idDetail_Overtimes: this.idCodeLkupsSelections,
            status: "NOT BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-overtime-charge-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        }
      });
    },

    removeSelections() {
      this.idCodeLkupsSelections = [];
      this.$refs[
        "list-billing-cml-billing-detail-handling-overtime"
      ].unselectAllInternal();
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.idCodeLkupsSelections = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.idCodeLkupsSelections.push(item.idDetail_Overtime);
      });
    },

    endOvertimeChange() {
      if (this.endOvertime.startDate && this.endOvertime.endDate) {
        this.endOvertimeFrom = this.$moment(
          String(this.endOvertime.startDate)
        ).format("YYYY-MM-DD");
        this.endOvertimeTo = this.$moment(
          String(this.endOvertime.endDate)
        ).format("YYYY-MM-DD");
        this.loadItems();
      }
    },

    clearendOvertimeChange() {
      this.endOvertime = {
        startDate: null,
        endDate: null,
      };
      this.endOvertimeFrom = "";
      this.endOvertimeTo = "";
      this.loadItems();
    },

    startOvertimeChange() {
      if (this.startOvertime.startDate && this.startOvertime.endDate) {
        this.startOvertimeFrom = this.$moment(
          String(this.startOvertime.startDate)
        ).format("YYYY-MM-DD");
        this.startOvertimeTo = this.$moment(
          String(this.startOvertime.endDate)
        ).format("YYYY-MM-DD");
        this.loadItems();
      }
    },

    clearstartOvertimeChange() {
      this.startOvertime = {
        startDate: null,
        endDate: null,
      };
      this.startOvertimeFrom = "";
      this.startOvertimeTo = "";
      this.loadItems();
    },

    backForm() {
      var params = this.$onRandom(this.$route.params.idBillingHeader);
      window.location.href = "/billing-cml/billing/header/detail/" + params;
    },

    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      });
      return formatter.format(value);
    },

    downloadData() {
      var params = this.$onBehind(this.$route.params.idBillingDetail);
      const userDatas = this.$getUserInfo();
      var roleName = userDatas.sub.role.name;
      var hideRate = "";
      if (
        roleName == "om_cml_basf01" ||
        roleName == "om_cml_basf02_rm" ||
        roleName == "om_cml_basf02_fg"
      ) {
        hideRate = "-hide-rate";
      }
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-overtime-charge" +
        hideRate +
        "/" +
        params[0];
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      let startOvertimeFrom = this.startOvertimeFrom;
      let startOvertimeTo = this.startOvertimeTo;

      let endOvertimeFrom = this.endOvertimeFrom;
      let endOvertimeTo = this.endOvertimeTo;

      return this.$http
        .get(
          baseURI +
            `?idDetail_Overtime=${this.serverParams.columnFilters.idDetail_Overtime}&transactionType=${this.serverParams.columnFilters.transactionType}&startOvertimeFrom=${startOvertimeFrom}&startOvertimeTo=${startOvertimeTo}&endOvertimeFrom=${endOvertimeFrom}&endOvertimeTo=${endOvertimeTo}&nik=${this.serverParams.columnFilters.nik}&name=${this.serverParams.columnFilters.name}&name=${this.serverParams.columnFilters.name}&position=${this.serverParams.columnFilters.position}&reason=${this.serverParams.columnFilters.reason}&sbu_sku=${this.serverParams.columnFilters.sbu_sku}&status=${this.serverParams.columnFilters.status}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    // load items is what brings back the rows from server
    loadItems() {
      var params = this.$onBehind(this.$route.params.idBillingDetail);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-overtime-charge/" +
        params[0];
      this.isLoading = true;

      let startOvertimeFrom = this.startOvertimeFrom;
      let startOvertimeTo = this.startOvertimeTo;

      let endOvertimeFrom = this.endOvertimeFrom;
      let endOvertimeTo = this.endOvertimeTo;

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idDetail_Overtime=${this.serverParams.columnFilters.idDetail_Overtime}&transactionType=${this.serverParams.columnFilters.transactionType}&startOvertimeFrom=${startOvertimeFrom}&startOvertimeTo=${startOvertimeTo}&endOvertimeFrom=${endOvertimeFrom}&endOvertimeTo=${endOvertimeTo}&nik=${this.serverParams.columnFilters.nik}&name=${this.serverParams.columnFilters.name}&name=${this.serverParams.columnFilters.name}&position=${this.serverParams.columnFilters.position}&reason=${this.serverParams.columnFilters.reason}&sbu_sku=${this.serverParams.columnFilters.sbu_sku}&status=${this.serverParams.columnFilters.status}`,
          { timeout: 60000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.roleName = userDatas.sub.role.name;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "BillingCmlController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      this.loadData();
    },

    loadData() {
      this.isLoading = true;

      var params = this.$onBehind(this.$route.params.idBillingDetail);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail/" +
        params[0];
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
          this.forms.amountCategory = this.toCurrency(
            response.data.datas.amountCategory
          );
          this.forms.rate = this.toCurrency(response.data.datas.rate);
          this.formsHeader = response.data.datas.bm_billing_header;
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.getDataDropdownList();
    this.fetchIt();
    this.loading();
    this.columns = this.getTableColumns();
  },
};
</script>

<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>
